import styled, { css } from 'styled-components';
import { SpeedDialAction, SpeedDial } from '@mui/material';
import { theme } from 'styles/mui-config';

export const StyledSppedDial = styled(SpeedDial)` 
    & button{
        width:44px;
        height:44px;
        & svg{
            font-size:18px !important;
        }
    }
    
`
////////////////////////////////////////

const boxShadow = ({ active }) => {
    if (active === "yes") {
        return css`
           background: linear-gradient(145deg, #e6e6e6, #ffffff);
           box-shadow:  19px 19px 37px #d9d9d9,-19px -19px 37px #ffffff !important;
        `
    }

}
export const StyledSpeedDialAction = styled(SpeedDialAction)`
    width:38px !important;
    height:38px !important;
    font-size:18px;
    color:${props => props.active === "yes" ? theme.palette.primary.dark : theme.palette.secondary.dark} !important;
    ${boxShadow};
    &:hover{
        background-color: ${theme.palette.secondary.main} !important;
    }

`

